<template>
  <!--  英雄回家-->
  <div class="Herohome">
    <div class="contentnr">
      <div class="content">
        <ul class="content-list clearfix">
          <li class="content-list-li" >
            <div  class="listimg enlarge" @click="handleHerf(onedata.basicId)">
              <img v-lazy= onedata.basicThumbnail />
              <div class="listtitle"  @click="handleHerf(onedata.basicId)">
                <div :title=onedata.basicTitle   class="title-text" v-html="onedata.basicTitle"></div>
              </div>
            </div>
          </li>
          <li class="content-list-li" v-for="(item,index) in datalist" :key="index" >
            <div  class="listimg enlarge" @click="handleHerf(item.basicId)">
              <img v-lazy=item.basicThumbnail />
            </div>
            <div class="listtitle">
              <div :title=item.basicTitle   class="title-text"  @click="handleHerf(item.basicId)" v-html="item.basicTitle"></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import util from '@/assets/js/util'
  import {
    getyxhjJsondata
  } from '@/api/herohome.js'
  export default {
    data() {
      return {
        isdata: false,
        datalist: [],
        onedata:""
      }
    },
    mounted() {
      this._initdata()
    },
    methods: {
      _initdata() {
        getyxhjJsondata().then(res => {
            if (res.length > 0) {
              if (!util.isEmpty(res)) {
                this.isdata = false;
                this.datalist = res.slice(1,9)
                this.datalist.forEach((item)=>{
                  item.Title = item.basicTitle.length>45?item.basicTitle.substring(0,45):item.basicTitle;
                })
                this.onedata= res.slice(0,1)[0]
                this.onedata.Title = this.onedata.basicTitle.length>45?this.onedata.basicTitle.substring(0,20):this.onedata.basicTitle;
              } else {
                this.isdata = true
                this.datalist=[]
              }
            } else {
              this.isdata = true
              this.datalist=[]
            }
          }
        ).catch((err) => {
          this.isdata = true
          this.datalist=[]
        })
      },
      handleHerf(id) {
        //直接调用$router.push 实现携带参数的跳转
        let routetele = this.$router.resolve({
          path: `/Details/${id}`,
        })
        window.open(routetele.href, '_blank');
      },
    }
  }
</script>
<style scoped>
  @media screen and (max-width:1366px) {
    .listtitle{
      font-size: 24px !important;
      line-height: 38px !important;
    }
    .content-list>li{
      margin-bottom: 60px !important;
    }
  }
  .Herohome{
    width: 100%;
    height: 100%;
  }
  .contentnr{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    padding-top: 100px;
    box-sizing: border-box;
  }
  .content{
    width: 1306px;
  }
  .content-list{
    width: 1306px;
  }
  .content-list>li{
    float: left;
    margin-left: 10px;
    width: 250px;
    height: 312px;
    box-shadow: 1px 2px 6px 0px rgba(118, 103, 1, 0.35);
    margin-bottom: 30px;
  }
  .content-list>li:nth-child(1){
    width: 500px;
    margin-right: 10px;
  }
  .content-list>li:nth-child(1)>.listimg{
    width: 100%;
    position: relative;
    height: 312.5px;
  }
  .content-list>li:nth-child(1)>.listimg>.listtitle{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.4);
    color: white;
    font-size: 16px;
  }
  .listimg {
    width: 100%;
    height: 155.5px;
    cursor: pointer;
  }

  .listimg img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .listtitle {
    box-sizing: border-box;
    text-align: left;
    width: 100%;
    height: 160px;
    padding: 19.7px;
    line-height: 26px;
    font-size: 16px;
    color: #000000;
    overflow: hidden;
    cursor: pointer;
    background-color: white;
  }
  .listtitle:hover {
    color: #40A9FF;
  }
  .content-list-li:nth-child(1){
    position: relative;
    pointer-events: auto;
  }
/*  .content-list-li:nth-child(1):after{
    display: block;
    content: "正在直播";
    position: absolute;
    padding: 3px;
    font-size: 20px;
    background-color: red;
    color: white;
    right: 0;
    top: 0;
    pointer-events: none;
  }
  .content-list-li:nth-child(1):before{
    display: block;
    content: "";
    width: 60px;
    height: 60px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    background: url("../../../assets/img/play-red.png") no-repeat;
    background-size: 100% 100%;
    z-index: 100;
    cursor: pointer;
    opacity: 1;
    pointer-events: none;
  }*/


</style>



// WEBPACK FOOTER //
// src/pages/Home/components/herohome.vue